import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOrganizations } from '../../../redux/lutien';
import { RootState } from '../../../redux/store';
import { FailedEventsHeader } from './components/FailedEventsHeader';
import { PageContainer } from './components/PageContainer';
import { FailedEventsView } from './failed-events.view';
import { useFetchPaginatedEventFailures } from './useFetchPagedEventFailures';

export default function FailedEventsContainer() {
  const dispatch = useDispatch();
  const { organizations } = useSelector((state: RootState) => state.lutien);
  const [forceTableReset, setForceTableReset] = useState(0);

  const {
    selectedStatus,
    setSelectedStatus,
    eventFailures,
    fetchNextPage,
    isFetching,
    totalEntities,
    retryEvent,
    updateEvent,
    ignoreEvent
  } = useFetchPaginatedEventFailures();

  useEffect(() => {
    (dispatch as any)(getOrganizations());
  }, [dispatch]);

  return (
    <PageContainer
      header={
        <FailedEventsHeader
          selectedStatus={selectedStatus}
          handleChange={setSelectedStatus}
          refreshTableFn={() => {
            fetchNextPage({ page: 0, pageSize: 20 });
            setForceTableReset(old => old + 1);
          }}
        />
      }>
      <FailedEventsView
        key={forceTableReset + (selectedStatus ?? '')}
        organizations={organizations}
        eventFailures={eventFailures}
        fetchNextPage={fetchNextPage}
        totalRows={totalEntities}
        updateEvent={updateEvent}
        retryEvent={retryEvent}
        ignoreEvent={ignoreEvent}
        isFetching={isFetching}></FailedEventsView>
    </PageContainer>
  );
}
